/** Customer-facing payload after public proposal approval (success screen). */
export type ProposalApprovalSuccessPayload = {
  proposalId: number;
  proposalRef: string;
  /** Customer-facing proposal title when available. */
  proposalTitle?: string | null;
  proposalTotal: number;
  finalAgreedPrice: number;
  gstAmount: number;
  finalPayableAmount: number;
  invoiceGstEnabled: boolean;
  confirmationEmail: string;
  /** Friendly email delivery status for the success screen. */
  confirmationEmailStatus?: "sent" | "failed" | "queued" | "not_requested" | null;
  invoiceNumber?: string | null;
  invoiceUrl?: string | null;
  approvedProposalPdfUrl?: string | null;
  /** Approval recorded but PDF email could not be delivered — do not ask to re-approve. */
  pdfEmailDeliveryFailed?: boolean;
  pdfEmailDeliveryMessage?: string | null;
  /** WhatsApp OTP evidence summary (optional; shown when available). */
  approverName?: string | null;
  verifiedWhatsAppDisplay?: string | null;
  approvedAtSingapore?: string | null;
  /** Explicit next step after approval; never infer group/no-payment states from a missing URL. */
  paymentHandoff?: ProposalApprovalPaymentHandoff;
};

export type ProposalApprovalPaymentHandoff =
  | {
      kind: "payment_required";
      invoiceNumber: string;
      invoiceUrl: string;
      invoiceStatus: "raised" | "outstanding";
    }
  | {
      kind: "payment_received";
      invoiceNumber: string;
      invoiceUrl: string | null;
      invoiceStatus: "paid";
    }
  | {
      kind: "group_billing";
      invoiceNumber: null;
      invoiceUrl: null;
      invoiceStatus: null;
    }
  | {
      kind: "no_additional_payment";
      invoiceNumber: null;
      invoiceUrl: null;
      invoiceStatus: null;
    }
  | {
      kind: "payment_arrangement_pending";
      invoiceNumber: string | null;
      invoiceUrl: string | null;
      invoiceStatus: string | null;
    };

export const PROPOSAL_APPROVAL_SUCCESS_STORAGE_KEY = "clarity:proposalApprovalSuccess";
